import React, { useEffect } from 'react';
import StoryCard from 'components/shared/StoryCard';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import axios from 'axios';



const LatestStories = () => {

    const [latestStoriesData, setLatestStoriesData] = React.useState([]);

    useEffect(() => {
        const fetchLatestStories = async () => {
            try {
                const config = {
                    headers: {
                        'Accept': 'application/json',
                    }
                };
            
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/cuentos`, config);
                console.log('Latest stories:', response.data);
                setLatestStoriesData(response.data);
            } catch (error) {
                console.error('Error fetching latest stories:', error);
            }
        };

        fetchLatestStories();
    }, []);

    const responsive = {
        LargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 1300 },
          items: 3
        },
        desktop: {
          breakpoint: { max: 1300, min: 1024 },
          items: 2
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };


    return (
        <div className="md:px-44 px-10 py-16 bg-sage-50 select-none">
            <div className="text-center mb-12">
                <h1 className="text-5xl md:text-6xl font-bold mb-4 text-japanese-ink font-japanese">
                    📚 Novedades
                </h1>
            </div>     
            
            <Carousel
                swipeable={true}
                draggable={true}
                showDots={true}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="z-10"
                removeArrowOnDeviceType={["mobile"]}
                dotListClass="custom-dot-list-style"
                itemClass="w-[272px] md:w-[30px] lg:w-[30px] xl:w-[30px] "
            >
                {latestStoriesData && latestStoriesData.map((story, index) => (
                <div key={index} className='px-2 mb-6'>
                <StoryCard 
                    data={story} 
                />
                </div>
            ))}
            </Carousel>
        </div>
    );
};


export default LatestStories;